<script>
import Layout from "@/router/layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import Datatable from "@/router/layouts/table-datatable.vue";
import Pagination from "@/router/layouts/table-pagination.vue";
import axios from "axios";
import Swal from "sweetalert2";
import _ from "lodash";

export default {
  page: {
    title: "Kompetensi",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    Datatable,
    Pagination,
  },
  data() {
    let sortOrders = []; // select sortOrder

    // definisi kolom yang dipakai
    let columns = [
      {
        width: "50px",
        label: "No",
        name: "idverif_kompetensi",
      },
      {
        width: "200px",
        label: "Nama Profesi",
        name: "nama_profesi",
      },
      {
        width: "auto",
        label: "Kode Kompetensi",
        name: "kode_kompetensi",
      },
      {
        width: "auto",
        label: "Nama Kompetensi",
        name: "nama_kompetensi",
      },
      {
        width: "auto",
        label: "Definisi",
        name: "definisi",
      },
      {
        width: "200px",
        label: "Aksi",
        name: "-",
      }, // jika tidak ada sorting kasih name dengan karakter -
    ];

    // cek sorting
    columns.forEach((column) => {
      sortOrders[column.name] = -1;
    });
    // Get hak akses
    const menu = "Kompetensi";

    return {
      title: menu,
      items: [
        {
          text: "Verifikasi",
          href: "/",
        },
        {
          text: "Kompetensi",
          active: true,
        },
      ],
      // isWrite: localStorage.getItem("isWrite"),
      isWrite: 1,
      showModal: false,
      isEdit: false,
      selected_id: "",
      namePathUrl: this.$route.name,
      sessionRoleId: localStorage.session_role_active_id,
      loadingTable: true,
      table_data: [],
      columns: columns,
      sortKey: "idverif_kompetensi", // sort key awal
      sortOrders: sortOrders,
      currentTablePage: "",
      tableFilter: {
        page: 1,
        per_page: 10,
        search: "",
        column: "idverif_kompetensi",
        dir: "desc",
        filter: {
          active_flag: 1,
          id_mprofesi: null,
        },
      },

      form: {
        kode_kompetensi: "",
        nama_kompetensi: "",
        definisi: "",
        id_mprofesi: null,
      },

      // config untuk paginasi
      pagination: {
        lastPage: "",
        currentPage: "",
        total: "",
        lastPageUrl: "",
        nextPageUrl: "",
        prevPageUrl: "",
        from: "",
        to: "",
        links: "",
      },
      optionProfesi: [],
    };
  },
  async mounted() {
    this.getDataTable();
    this.getProfesi();
    this.filterProfesi = _.debounce(this.searchProfesi.bind(this), 500);
    this.filterSearch = _.debounce(this.onSearchInput.bind(this), 500);
  },
  methods: {
    getDataTable(
      url = process.env.VUE_APP_BACKEND_URL_VERSION + "verifikasi/kompetensi",
    ) {
      let self = this;
      self.loadingTable = true;

      var config = {
        method: "get",
        url: url,
        params: self.tableFilter,
        headers: {
          Accept: "application/json",
          Authorization: "Bearer " + localStorage.access_token,
        },
      };

      axios(config)
        .then((response) => {
          let response_data = response.data;
          let response_data_fix = response_data.data;
          if (response_data.meta.code == 200) {
            console.log(response_data_fix);
            self.table_data = response_data_fix.data;
            self.configPagination(response_data_fix);
            self.currentTablePage = response_data_fix.current_page;
            self.loadingTable = false;
          } else {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: response_data.meta.message,
            });
          }
        })
        .catch((errors) => {
          console.log(errors);
          self.loadingTable = false;
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text:
              errors.response?.data?.meta?.message ||
              "Gagal mengambil data.",
          });
        });
    },
    configPagination(data) {
      let self = this;
      self.pagination.lastPage = data.last_page;
      self.pagination.currentPage = data.current_page;
      self.pagination.total = data.total;
      self.pagination.lastPageUrl = data.last_page_url;
      self.pagination.nextPageUrl = data.next_page_url;
      self.pagination.prevPageUrl = data.prev_page_url;
      self.pagination.from = data.from;
      self.pagination.to = data.to;
      self.pagination.links = data.links;
    },
    sortBy(key) {
      this.sortKey = key;
      this.sortOrders[key] = this.sortOrders[key] * -1;
      this.tableFilter.column = key;
      this.tableFilter.dir = this.sortOrders[key] === 1 ? "asc" : "desc";
      this.getDataTable();
    },
    toPage(url) {
      if (!url) return;
      let link = new URLSearchParams(url.split("?")[1] || "");
      this.tableFilter.page = link.get("page");
      this.getDataTable();
    },
    resetForm() {
      this.form = {
        kode_kompetensi: "",
        nama_kompetensi: "",
        definisi: "",
        id_mprofesi: null,
      };
      this.selected_id = "";
    },
    create() {
      this.resetForm();
      this.isEdit = false;
      this.showModal = true;
    },
    edit(data) {
      this.isEdit = true;
      this.selected_id = data.idverif_kompetensi;
      this.form = {
        kode_kompetensi: data.kode_kompetensi,
        nama_kompetensi: data.nama_kompetensi,
        definisi: data.definisi,
        id_mprofesi: data.id_mprofesi,
      };
      this.showModal = true;
    },
    save() {
      let self = this;
      let url =
        process.env.VUE_APP_BACKEND_URL_VERSION + "verifikasi/kompetensi";
      let method = "post";

      if (self.isEdit) {
        url += "/" + self.selected_id;
        method = "put";
      }

      Swal.fire({
        title: "Sedang memproses data...",
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });

      axios({
        method: method,
        url: url,
        data: self.form,
        headers: {
          Accept: "application/json",
          Authorization: "Bearer " + localStorage.access_token,
        },
      })
        .then((response) => {
          if (response.data.meta.code == 200) {
            Swal.fire({
              icon: "success",
              title: "Berhasil",
              text: response.data.meta.message,
            });
            self.showModal = false;
            self.getDataTable();
          } else {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: response.data.meta.message,
            });
          }
        })
        .catch((error) => {
          let message = "Terjadi kesalahan";

          const metaMessage = error?.response?.data?.meta?.message;
          const validationErrors = error?.response?.data?.data?.error;

          if (
            metaMessage === "Validation failed" &&
            Array.isArray(validationErrors)
          ) {
            message = `
              <ul style="text-align:left;">
                ${validationErrors.map((err) => `<li>${err}</li>`).join("")}
              </ul>
            `;
          } else if (metaMessage) {
            message = metaMessage;
          }

          Swal.fire({
            icon: "error",
            title: "Oops...",
            html: message, // pakai html, bukan text
          });
        });
    },
    changeStatus(data) {
      let self = this;
      let url =
        process.env.VUE_APP_BACKEND_URL_VERSION +
        "verifikasi/kompetensi/" +
        data.idverif_kompetensi +
        "/status";
      let method = "put";

      Swal.fire({
        title: "Apakah anda yakin?",
        text:
          data.active_flag == 1
            ? "Data akan dinonaktifkan!"
            : "Data akan diaktifkan kembali!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: "Ya, Lanjutkan!",
        cancelButtonText: "Batalkan",
      }).then((result) => {
        if (result.isConfirmed) {
          Swal.fire({
            title: "Sedang memproses data...",
            allowOutsideClick: false,
            didOpen: () => {
              Swal.showLoading();
            },
          });

          axios({
            method: method,
            url: url,
            headers: {
              Accept: "application/json",
              Authorization: "Bearer " + localStorage.access_token,
            },
          })
            .then((response) => {
              if (response.data.meta.code == 200) {
                Swal.fire({
                  icon: "success",
                  title: "Berhasil",
                  text: response.data.meta.message,
                });
                self.getDataTable();
              } else {
                Swal.fire({
                  icon: "error",
                  title: "Oops...",
                  text: response.data.meta.message,
                });
              }
            })
            .catch((error) => {
              Swal.fire({
                icon: "error",
                title: "Oops...",
                text:
                  error.response?.data?.meta?.message || "Terjadi kesalahan",
              });
            });
        }
      });
    },
    deleteData(data) {
      let self = this;
      let url =
        process.env.VUE_APP_BACKEND_URL_VERSION +
        "verifikasi/kompetensi/" +
        data.idverif_kompetensi;
      let method = "delete";

      Swal.fire({
        title: "Apakah anda yakin?",
        text: "Data akan dihapus secara permanen!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: "Ya, Lanjutkan!",
        cancelButtonText: "Batalkan",
      }).then((result) => {
        if (result.isConfirmed) {
          Swal.fire({
            title: "Sedang memproses data...",
            allowOutsideClick: false,
            didOpen: () => {
              Swal.showLoading();
            },
          });

          axios({
            method: method,
            url: url,
            headers: {
              Accept: "application/json",
              Authorization: "Bearer " + localStorage.access_token,
            },
          })
            .then((response) => {
              if (response.data.meta.code == 200) {
                Swal.fire({
                  icon: "success",
                  title: "Berhasil",
                  text: response.data.meta.message,
                });
                self.getDataTable();
              } else {
                Swal.fire({
                  icon: "error",
                  title: "Oops...",
                  text: response.data.meta.message,
                });
              }
            })
            .catch((error) => {
              Swal.fire({
                icon: "error",
                title: "Oops...",
                text:
                  error.response?.data?.meta?.message || "Terjadi kesalahan",
              });
            });
        }
      });
    },
    async searchProfesi(search, loading) {
      loading(true);
      await this.getProfesi(search, loading);
    },
    async getProfesi(search = "", loading) {
      await axios
        .get(
          process.env.VUE_APP_BACKEND_URL_VERSION + "referensi/profesi/all",
          {
            params: {
              search: search,
              limit: 200,
            },
            headers: {
              Authorization: `Bearer ${localStorage.access_token}`,
            },
          },
        )
        .then((response) => {
          this.optionProfesi = response.data.data;
          if (loading) loading(false);
        });
    },
    onFilterChange() {
      this.tableFilter.page = 1;
      this.getDataTable();
    },
    onSearchInput() {
      this.tableFilter.page = 1;
      this.getDataTable();
    },
    resetFilter() {
      this.tableFilter.search = "";
      this.tableFilter.filter.id_mprofesi = null;
      this.tableFilter.filter.active_flag = 1;
      this.tableFilter.page = 1;
      this.getDataTable();
    },
  },
};
</script>
<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-md-6">
                <!-- <div class="card-title">List Data</div> -->
              </div>
              <div class="col-md-6">
                <div class="text-end">
                  <button
                    class="btn btn-success btn-sm"
                    @click="create()"
                    v-if="isWrite || isWrite == 1"
                  >
                    <i class="fa fa-plus me-1"></i> Tambah
                  </button>
                </div>
              </div>
              <div class="row mt-2 g-3 align-items-end">
                <hr class="mt-0" />
                <div class="form-group col-md-3">
                  <label for="filterStatus" class="form-label fw-semibold">Status Aktif</label>
                  <select
                    class="form-control"
                    id="filterStatus"
                    v-model="tableFilter.filter.active_flag"
                    @change="onFilterChange()"
                  >
                    <option value="">Semua Status</option>
                    <option value="1">Aktif</option>
                    <option value="0">Tidak Aktif</option>
                  </select>
                </div>

                <div class="form-group col-md-4">
                  <label class="form-label fw-semibold">Filter Profesi (Dropdown Search)</label>
                  <v-select
                    class="style-chooser"
                    :options="optionProfesi"
                    :reduce="(item) => item.id_mprofesi"
                    label="nama_profesi"
                    v-model="tableFilter.filter.id_mprofesi"
                    placeholder="Semua Profesi (Ketik untuk cari...)"
                    :clearable="true"
                    @search="filterProfesi"
                    @update:modelValue="onFilterChange()"
                  />
                </div>

                <div class="form-group col-md-3">
                  <label for="filterSearch" class="form-label fw-semibold">Cari Data</label>
                  <div class="input-group">
                    <span class="input-group-text bg-light"><i class="fa fa-search text-muted"></i></span>
                    <input
                      type="text"
                      class="form-control"
                      id="filterSearch"
                      placeholder="Cari kode, nama, definisi..."
                      v-model="tableFilter.search"
                      @input="filterSearch()"
                    />
                  </div>
                </div>

                <div class="form-group col-md-2">
                  <button
                    type="button"
                    class="btn btn-outline-secondary w-100"
                    @click="resetFilter()"
                    title="Reset Filter"
                  >
                    <i class="fa fa-rotate-left me-1"></i> Reset
                  </button>
                </div>
              </div>
              <div class="row mt-2">
                <hr />
                <div class="col-12">
                  <table class="mb-2">
                    <tr>
                      <td>Show</td>
                      <td>
                        <select
                          class="form-control form-control-sm"
                          id="showpaginatetable"
                          v-model="tableFilter.per_page"
                          @change="getDataTable()"
                        >
                          <option value="10">10</option>
                          <option value="50">50</option>
                          <option value="100">100</option>
                          <option value="200">200</option>
                          <option value="500">500</option>
                        </select>
                      </td>
                      <td>Entries</td>
                    </tr>
                  </table>
                </div>

                <datatable
                  :columns="columns"
                  :sortKey="sortKey"
                  :sortOrders="sortOrders"
                  @sort="sortBy"
                >
                  <tbody>
                    <tr v-if="loadingTable">
                      <td class="text-center" colspan="99">
                        <i class="fas fa-spinner fa-spin"></i> Loading...
                      </td>
                    </tr>
                    <tr v-else-if="table_data == ''">
                      <td class="text-center" colspan="99">
                        Data Tidak Tersedia
                      </td>
                    </tr>
                    <tr
                      v-else
                      v-for="(row_data, key_data) in table_data"
                      :key="key_data"
                    >
                      <td>{{ key_data + pagination.from }}</td>
                      <td style="width: 200px; max-width: 220px;">
                        <div
                          v-if="row_data.profesi && row_data.profesi.nama_profesi"
                          class="text-profesi"
                        >
                          {{ row_data.profesi.nama_profesi }}
                        </div>
                        <span v-else class="text-muted">-</span>
                      </td>
                      <td>
                        {{ row_data.kode_kompetensi }}
                      </td>
                      <td>
                        {{ row_data.nama_kompetensi }}
                      </td>
                      <td>
                        {{ row_data.definisi }}
                      </td>
                      <td class="text-center">
                        <div class="btn-group">
                          <button
                            type="button"
                            class="btn btn-warning btn-sm"
                            v-if="isWrite || isWrite == 1 && row_data.active_flag == 1"
                            v-on:click="edit(row_data)"
                          >
                            <i class="fa fa-edit"></i> Edit
                          </button>
                          <button
                            type="button"
                            class="btn btn-danger btn-sm"
                            v-if="isWrite || isWrite == 1 && row_data.active_flag == 1"
                            @click="changeStatus(row_data)"
                          >
                            <i class="fa fa-trash"></i> Disable
                          </button>
                          <button
                            type="button"
                            class="btn btn-warning btn-sm"
                            v-if="isWrite || isWrite == 1 && row_data.active_flag == 0"
                            @click="changeStatus(row_data)"
                          >
                            <i class="fa fa-recycle"></i> Enable
                          </button>
                          <button
                            type="button"
                            class="btn btn-danger btn-sm"
                            v-if="isWrite || isWrite == 1 && row_data.active_flag == 0"
                            v-on:click="deleteData(row_data)"
                          >
                            <i class="fa fa-trash"></i> Hapus
                          </button>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </datatable>
              </div>
            </div>
            <pagination :pagination="pagination" @to-page="toPage"></pagination>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal Form -->
    <b-modal
      v-model="showModal"
      :title="isEdit ? 'Edit Kompetensi' : 'Tambah Kompetensi'"
      title-class="text-black font-18"
      body-class="p-4"
      hide-footer
    >
      <form @submit.prevent="save">
        <div class="form-group mb-3">
          <label>Profesi</label>
          <v-select
            class="style-chooser"
            :options="optionProfesi"
            :reduce="(item) => item.id_mprofesi"
            label="nama_profesi"
            v-model="form.id_mprofesi"
            placeholder="Profesi"
            @search="filterProfesi"
          />
        </div>
        <div class="form-group mb-3">
          <label>Kode Kompetensi</label>
          <input
            v-model="form.kode_kompetensi"
            type="text"
            class="form-control"
            placeholder="Masukkan Kode Kompetensi"
          />
        </div>
        <div class="form-group mb-3">
          <label>Nama Kompetensi <span class="text-danger">*</span></label>
          <input
            v-model="form.nama_kompetensi"
            type="text"
            class="form-control"
            placeholder="Masukkan Nama Kompetensi"
            required
          />
        </div>
        <div class="form-group mb-3">
          <label>Definisi</label>
          <textarea
            v-model="form.definisi"
            class="form-control"
            placeholder="Masukkan Definisi"
            rows="3"
          ></textarea>
        </div>
        <div class="text-end mt-4">
          <button
            type="button"
            class="btn btn-light me-1"
            @click="showModal = false"
          >
            Tutup
          </button>
          <button type="submit" class="btn btn-success">Simpan</button>
        </div>
      </form>
    </b-modal>
  </Layout>
</template>

<style scoped>
.text-profesi {
  white-space: normal;
  word-break: break-word;
  line-height: 1.4;
}
</style>
